import Vue from 'vue'
import VueRouter from 'vue-router'
/*
import FrmNewEvent from '../components/FrmPlanning/FrmNewEvent.vue'
import Page_FormClienteSede from '../components/FrmPlanning/Page_FormClienteSede.vue'
import Page_FormDataOra from '../components/FrmPlanning/Page_FormDataOra.vue'
import Page_FormOperatore from '../components/FrmPlanning/Page_FormOperatore.vue'
*/
import Plan from '../views/Plan.vue'
import Planner from '../views/Planner.vue'
import PlannerVehicles from '../views/PlannerVehicles.vue'
import PlannerEquipments from '../views/PlannerEquipments.vue'
import PlannerOperators from '../views/PlannerOperators.vue'
import Signup from '../views/Signup.vue'
import EditCompany from '../views/EditCompany.vue'
import ManageUsers from '../views/ManageUsers.vue'
import ManagePermissions from '../views/ManagePermissions.vue'
import Login from '../views/Login.vue'
import LoginOwner from '../views/LoginOwner.vue'
import Dashboard from '../views/Dashboard.vue'
import OwnerDashboard from '../views/OwnerDashboard.vue'
import ManageResources from '../views/ManageResources.vue'
import ManageCustomers from '../views/ManageCustomers.vue'
import EventViewerPage from '../views/EventViewerPage.vue'
import PlannerViewer from '../views/PlannerViewer.vue'
import UserProfile from '../views/UserProfile.vue'
import AgendaViewerPage from '../views/AgendaViewerPage.vue'
import EditSettings from '../views/EditSettings.vue'


Vue.use(VueRouter)

const routes = [
  { 
    name:"login-owner",
    path: '/',
    component: LoginOwner
  },
  {
    name:"login",
    path: '/:companyAlias/Login',
    component: Login
  },
  {
    name:"owner-dashboard",
    path: '/Dashboard',
    component: OwnerDashboard
  },
  {
    name:"dashboard",
    path: '/:companyAlias/Dashboard',
    component: Dashboard
  },

  {
    name:"company-edit",
    path:'/:companyAlias/Edit',
    component:EditCompany
  },

  {
    name:"user-profile",
    path:'/:companyAlias/Users/Current',
    component:UserProfile
  },

  {
    name:"user-profile-edit",
    path:'/:companyAlias/Users/:hashId/Edit',
    component:UserProfile
  },

  {
    name:"signup",
    path: '/Signup',
    component: Signup
  },

  {
    name:'manage-users',
    path: '/:companyAlias/Users',
    component: ManageUsers, 
  },
  {
    name:'manage-workers',
    path: '/:companyAlias/Workers',
    component: ManageResources, 
  },
  {
    name:'manage-customers',
    path: '/:companyAlias/Customers',
    component: ManageCustomers, 
  },
  {
    name:'event-viewer',
    path: '/:companyAlias/EventViewer', 
    component: EventViewerPage, 
  },

  {
    name:'manage-roles',
    path: '/:companyAlias/Roles',
    component: ManagePermissions, 
  },

  {
    name:'plan',
    path: '/:companyAlias/Plan',
    component: Planner, 
  },

  {
    name:'plan-vehicles',
    path: '/:companyAlias/Plan/Vehicles',
    component: PlannerVehicles, 
  },
 
  {
    name:'plan-equipments',
    path: '/:companyAlias/Plan/Equipments',
    component: PlannerEquipments, 
  }, 
  {
    name:'plan-workers',
    path: '/:companyAlias/Plan/Workers',
    component: PlannerOperators, 
  },
  {
    name:'plan-viewer',
    path: '/:companyAlias/Planner/Viewer',
    component: PlannerViewer, 
  },
  {
    name:'agenda-viewer',
    path: '/:companyAlias/Agenda',
    component: AgendaViewerPage, 
  },
  {
    name:'customize',
    path: '/:companyAlias/Customize',
    component: EditSettings, 
  },
  {
    path: '*',
    redirect: { name: '' }
  }
]

const router = new VueRouter({mode: 'history',routes: routes});

export default router
